export { DisclosurePage as default } from '@/components/pages/Ir/Manage/Disclosure'
